import MarkerModel from "./MarkerModel";

class MarkerManager {
  // ---------------------------------------------------------------------------
  // --	MarkerManager
  // ---------------------------------------------------------------------------

  constructor(markers) {
    this.models = [];
    markers.forEach((marker) => {
      const model = new MarkerModel(marker);
      this.models.push(model);
    });
  }

  getProgress(scrollY) {
    for (let i = 0; i < this.models.length; i++) {
      //モデル参照
      const model = this.models[i];

      //範囲内の場合
      if (scrollY < model.getAnchorY()) {
        //最初のマーカーの前の時
        if (i <= 0) {
          return Object.assign({ index: 0, progress: 1 }, this.models[0].model);
        }

        //はじまりと終わりのマーカー参照
        const startModel = this.models[i - 1];
        const endModel = this.models[i];

        //範囲を取得
        const minY = startModel.getAnchorY();
        const maxY = endModel.getAnchorY();

        //進捗
        let progress = (scrollY - minY) / (maxY - minY);

        return {
          index: i,
          progress: progress,
          scale:
            startModel.scale + (endModel.scale - startModel.scale) * progress,
          alpha:
            startModel.alpha + (endModel.alpha - startModel.alpha) * progress,
        };
      }
    }

    return Object.assign(
      {
        index: this.models.length,
        progress: 1,
      },
      this.models[this.models.length - 1].model
    );
  }

  // ---------------------------------------------------------------------------
}

export default MarkerManager;
